import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import basicCoverPage from '../images/BasicCoverPage.png'; 
import ExtendedCoverPage from '../images/ExtendedCoverPage.png'; 
import CoverPageIMf from '../images/CoverPageIMf.png'; 
import FoundationCoverPage from '../images/FoundationCoverPage.png'; 
import ImfCog from '../images/IMfCog.png'; 
import TeamReport from '../images/TeamReport.png'; 
import EnneagramTeamReport from '../images/Sally Sample Enneagram Team Report.png'
import CouplesReport from '../images/SallySampleCouples.png'; 
import ProfessionalPairsReport from '../images/SallySampleProfessionalPairs.png'; 
import EnneaCoachOverview from '../images/EnneaCoachOverview.png'; 
import EnneagramOverview from '../images/EnneagramOverview.png';
import CombinedOverview from '../images/CombinedOverview.png';
import Brochure from '../images/AephoriaBrochureImage.png'
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from '@material-ui/core/styles';
import ReportLink from '../comps/reportLinks';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, 
  },
  
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'row',
  },
}));

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    color: 'white !important',
  },
}))(Tooltip);

// eslint-disable-next-line 
class Samples extends Component {  constructor(props) {
    super(props);
    this.state = {
        };  

        
  }

  render() {
    const classes = this.props.classes;

    return (
      <>
      <div className={classes.root}>
          <CssBaseline />
          <main className={classes.content}>
              <div className={classes.appBarSpacer} />
              <Container maxWidth="lg" className={classes.container}>
                  <Grid item xs={12} md={12} lg={12}>
                    <div id='container1'>
                      <div className='img-with-text grid1'>
                        <h3 style={{textAlign:"center"}}>Enneagram Report</h3>
                        <a href='../samples/Sally Sample Enneagram Report.pdf' target="_blank"><img className='sampleImages' src={basicCoverPage} alt='' style={{width:"200px", height:"300px"}}></img></a>
                        <ReportLink
                          links={[
                            { type: "html", languageCode: "AF", language: "Afrikaans", url: "/coachportal/reports/e/0496a644-4b13-45c0-93e1-962c6b100d52?language=afrikaans" },
                            { type: "html", languageCode: "EN", language: "English", url: "/coachportal/reports/e/0496a644-4b13-45c0-93e1-962c6b100d52" },
                            { type: "html", languageCode: "ES", language: "Spanish", url: "/coachportal/reports/e/0496a644-4b13-45c0-93e1-962c6b100d52?language=spanish" },
                            { type: "html", languageCode: "HU", language: "Hungarian", url: "/coachportal/reports/e/0496a644-4b13-45c0-93e1-962c6b100d52?language=hungarian" },
                            { type: "html", languageCode: "IT", language: "Italian", url: "/coachportal/reports/e/0496a644-4b13-45c0-93e1-962c6b100d52?language=italian" },
                            { type: "html", languageCode: "SK", language: "Slovakian", url: "/coachportal/reports/e/0496a644-4b13-45c0-93e1-962c6b100d52?language=slovak" },
                            { type: "pdf", languageCode: "AF", language: "Afrikaans", url: "../samples/Sally Sample Enneagram Report Afrikaans.pdf", download: true },
                            { type: "pdf", languageCode: "EN", language: "English", url: "../samples/Sally Sample Enneagram Report.pdf", download: true },
                            { type: "pdf", languageCode: "ES", language: "Spanish", url: "../samples/Sally Sample Enneagram Report Spanish.pdf", download: true },
                            { type: "pdf", languageCode: "HU", language: "Hungarian", url: "../samples/Sally Sample Enneagram Report Hungarian.pdf", download: true },
                            { type: "pdf", languageCode: "IT", language: "Italian", url: "../samples/Sally Sample Enneagram Report Italian.pdf", download: true },
                            { type: "pdf", languageCode: "SK", language: "Slovakian", url: "../samples/Sally Sample Enneagram Report Slovak.pdf", download: true },
                          ]}
                        />
                      </div>
                      <div className='img-with-text grid2'>
                        <h3 style={{textAlign:"center"}}>Maturity Report</h3>
                        <a href='../samples/Sally Sample Maturity Report.pdf' target="_blank"><img className='sampleImages' src={CoverPageIMf} alt='' style={{width:"200px", height:"300px"}}></img></a>
                        <ReportLink
                          links={[
                            { type: "html", languageCode: "EN", language: "English", url: "/coachportal/reports/m/0496a644-4b13-45c0-93e1-962c6b100d52" },
                            { type: "pdf", languageCode: "EN", language: "English", url: "../samples/Sally Sample Maturity Report.pdf", download: true },
                          ]}
                        />
                      </div>
                    </div >
                    <div id='container2'>
                      <div className='img-with-text grid3'>
                        <h3 style={{textAlign:"center"}}>Combined Report</h3>
                        <a href='../samples/Sally Sample Combined Report.pdf' target="_blank"><img className='sampleImages' src={FoundationCoverPage} alt='' style={{width:"200px", height:"300px"}}></img></a>
                        <ReportLink
                          links={[
                            { type: "html", languageCode: "EN", language: "English", url: "/coachportal/reports/c/0496a644-4b13-45c0-93e1-962c6b100d52" },
                            { type: "pdf", languageCode: "EN", language: "English", url: "../samples/Sally Sample Combined Report.pdf", download: true },
                          ]}
                        />
                      </div>
                      <div className='img-with-text grid4'>
                        <h3 style={{textAlign:"center"}}>Combined+ Report</h3>
                        <a href='../samples/Sally Sample Combined+ Report.pdf' target="_blank"><img className='sampleImages' src={ExtendedCoverPage} alt='' style={{width:"200px", height:"300px"}}></img></a>
                        <ReportLink
                          links={[
                            { type: "html", languageCode: "EN", language: "English", url: "/coachportal/reports/cp/0496a644-4b13-45c0-93e1-962c6b100d52" },
                            { type: "pdf", languageCode: "EN", language: "English", url: "../samples/Sally Sample Combined+ Report.pdf", download: true },
                          ]}
                        />
                      </div>
                    </div>
                    <div id='container3'>
                      <div className='img-with-text grid5'>
                        <h3 style={{textAlign:"center"}}>Enneagram Coach Overview</h3>
                        <a href='../samples/Sally Sample Enneagram Coach Overview.pdf' target="_blank"><img className='sampleImages' src={EnneaCoachOverview} alt='' style={{width:"300px", height:"200px"}}></img></a>
                        <ReportLink
                          links={[
                            { type: "pdf", languageCode: "EN", language: "English", url: "../samples/Sally Sample Enneagram Coach Overview.pdf", download: true },
                          ]}
                        />
                      </div>
                      <div className='img-with-text grid6'>
                        <h3 style={{textAlign:"center"}}>Enneagram Overview</h3>
                        <a href='../samples/Sally Sample Enneagram Overview.pdf' target="_blank"><img className='sampleImages' src={EnneagramOverview} alt='' style={{width:"300px", height:"200px"}}></img></a>
                        <ReportLink
                          links={[
                            { type: "pdf", languageCode: "EN", language: "English", url: "../samples/Sally Sample Enneagram Overview.pdf", download: true },
                          ]}
                        />
                      </div>
                      <div className='img-with-text grid7'>
                        <h3 style={{textAlign:"center"}}>Maturity Overview</h3>
                        <a href='../samples/Sally Sample Maturity Overview.pdf' target="_blank"><img className='sampleImages' src={ImfCog} alt='' style={{width:"300px", height:"200px"}}></img></a>
                        <ReportLink
                          links={[
                            { type: "pdf", languageCode: "EN", language: "English", url: "../samples/Sally Sample Maturity Overview.pdf", download: true },
                          ]}
                        />    
                      </div>                
                    </div> 
                    <div id='container3b'>
                      <div className='img-with-text grid7b'>
                        <h3 style={{textAlign:"center"}}>Combined Overview</h3>
                        <a href='../samples/Sally Sample Combined Overview.pdf' target="_blank"><img className='sampleImages' src={CombinedOverview} alt='' style={{width:"300px", height:"200px"}}></img></a>
                        <ReportLink
                          links={[
                            { type: "pdf", languageCode: "EN", language: "English", url: "../samples/Sally Sample Combined Overview.pdf", download: true },
                          ]}
                        />    
                      </div>                
                    </div> 
                    <div id='container4'>
                      <div className='img-with-text grid8'>
                        <h3 style={{textAlign:"center"}}>Combined Team Report</h3>
                        <a href='../samples/Sample Team Report.pdf' target="_blank"><img className='sampleImages' src={TeamReport} alt='' style={{width:"300px", height:"200px"}}></img></a>
                        <ReportLink
                          links={[
                            { type: "pdf", languageCode: "EN", language: "English", url: "../samples/Sample Team Report.pdf", download: true },
                          ]}
                        />          
                      </div>
                      <div className='img-with-text grid8'>
                        <h3 style={{textAlign:"center"}}>Enneagam Team Report</h3>
                        <a href='../samples/Sally Sample Enneagram Team Report.pdf' target="_blank"><img className='sampleImages' src={EnneagramTeamReport} alt='' style={{width:"300px", height:"200px"}}></img></a>
                        <ReportLink
                          links={[
                            { type: "pdf", languageCode: "EN", language: "English", url: "../samples/Sally Sample Enneagram Team Report.pdf", download: true },
                          ]}
                        />          
                      </div>
                    </div>
                    <div className='sampleContainer'>
                      <div className='img-with-text grid2'>
                        <h3 style={{textAlign:"center"}}>Couples Report</h3>
                        <a href='../samples/Sam and Sally Couples Report.pdf' target="_blank"><img className='sampleImages' src={CouplesReport} alt='' style={{width:"200px", height:"300px"}}></img></a>
                        <ReportLink
                          links={[
                            { type: "html", languageCode: "EN", language: "English", url: "/publish/reports/pair/33421272-8574-40d2-8d1e-797c7fdc6850" },
                            { type: "pdf", languageCode: "EN", language: "English", url: "../samples/Sam and Sally Couples Report.pdf", download: true },
                          ]}
                        />
                      </div>
                      <div className='img-with-text grid2'>
                        <h3 style={{textAlign:"center"}}>Professional Pairs Report</h3>
                        <a href='../samples/Sam and Sally Professional Pairs Report.pdf' target="_blank"><img className='sampleImages' src={ProfessionalPairsReport} alt='' style={{width:"200px", height:"300px"}}></img></a>
                        <ReportLink
                          links={[
                            { type: "pdf", languageCode: "EN", language: "English", url: "../samples/Sam and Sally Professional Pairs Report.pdf", download: true },
                          ]}
                        />
                      </div>
                    </div>
                    <div id='container4' style={{"padding":"3vh 0"}}>
                      <div className='img-with-text grid8'>
                        <h3 style={{textAlign:"center"}}>Aephoria Brochure</h3>
                        <a href='../samples/Aephoria Brochure.pdf' target="_blank"><img className='sampleImages' src={Brochure} alt='' style={{width:"200px", height:"300px"}}></img></a>
                        <ReportLink
                          links={[
                            { type: "pdf", languageCode: "EN", language: "English", url: "../samples/Aephoria Brochure.pdf", download: true },
                          ]}
                        />                      
                      </div>
                    </div>  
                  </Grid>
              </Container>
          </main>
      </div>
</>
    )
  }
}

// eslint-disable-next-line
export default () => {
  const classes = useStyles();
  return (
      <Samples classes={classes} />
  )
};
 
